"use strict";
var jun;
(function (jun) {
    var storefront;
    (function (storefront) {
        function getOptions(params) {
            return {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-Shopify-Storefront-Access-Token": jun.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
                    "Accept-Language": "*",
                },
                body: JSON.stringify(params),
            };
        }
        async function exeStoreFront(params, successFunc) {
            await jun.FetchUtil.fetch(jun.SHOPIFY_STOREFRONT_URL, getOptions(params), successFunc);
        }
        storefront.exeStoreFront = exeStoreFront;
    })(storefront = jun.storefront || (jun.storefront = {}));
})(jun || (jun = {}));
/// <reference path="../../library/env.d.ts" />
var jun;
(function (jun) {
    jun.SHOPIFY_STOREFRONT_URL = "/api/2026-01/graphql";
    jun.HOST_URL = location.protocol + "//" + location.hostname;
    jun.NOW_URL = jun.HOST_URL + location.pathname;
    jun.CART_URL = jun.HOST_URL + "/cart";
    jun.COMMA = ",";
    jun.HYPHEN = "-";
    jun.DOUBLE_QUOTE = '"';
    jun.BLANK = "";
    jun.ZERO = "0";
    jun.MINUS = "-";
    jun.HALF_SPACE = " ";
    jun.HTML_YEN = "&yen;";
    jun.TR = "tr";
    jun.CLASS_HIDE = "hide";
    jun.REGEXP_LOC = /JUN_APP_LOC/;
    jun.REGEXP_PNT_MLT = /point_(\d+)/;
    jun.REGEXP_TEL = /^([0-9]{10,20}|[0-9-]{10,20})$/;
    jun.LOC_FBZ = "JUN_APP_LOC_FBZ";
    jun.LOC_DST = "JUN_APP_LOC_DST";
    jun.TAG_RDC_TAX = "#軽減税率対象";
    //社員タグ
    jun.TAG_JUN_MEMBER = "#JUNMEMBER";
    jun.PRD_RSV_FLG = "TRUE";
    jun.PRD_NML_FLG = "FALSE";
    jun.PRD_GFT = "ギフト";
    jun.ATTR_GIFT_KEY = "ギフト希望";
    jun.ATTR_RSV_DELIV_DATE_KEY = "お届け予定日";
    jun.ATTR_GID_KEY = "gid";
    jun.ATTR_USE_POINT_KEY = "使用ポイント";
    jun.ATTR_CUSTOMER_RANK_KEY = "会員ランク";
    jun.ATTR_FAMILY_CODE_KEY = "社員コード";
    jun.ATTR_ESTIMATED_POINT = "獲得予定ポイント";
    jun.ATTR_COD_FEE = "代引手数料";
    jun.ATTR_TAX_INCLUDED_AMOUNT = "_tax_included_amount";
    jun.ATTR_CART_ID_KEY = "_cartId";
    jun.ATTR_LINES = "_lines";
    jun.GIFT_VAL_YES = "希望する";
    jun.CST_BLK = "ブラック";
    jun.TRANSACTION_CASH_ON_DELIV = "代金引換";
    jun.ERROR_CODE_ADDRESS_MISMATCH = "ZIP-001";
    jun.ERROR_CODE_INVENTORY_OVER = "INV-001";
    jun.ERROR_CODE_INVALID_TEL = "TEL-001";
    jun.TAX_RATE_NML = 0.1;
    jun.TAX_RATE_RDC = 0.08;
    jun.CASH_ON_DELIV_FREE = 11000;
    jun.CASH_ON_DELIV_FEE = 330;
    jun.ATTR_OUTLET_KEY = "価格タイプ";
    jun.ATTR_OUTLET_VAL = "アウトレット";
    jun.WHEEL_FROM_TIME = "2022-01-01 00:00:00"; // 20211221 JUN-752
    jun.WHEEL_TO_TIME = "2022-01-04 00:00:00"; // 20211221 JUN-752
    jun.SOCIAL_PLUS_VER2_START = "2040-12-31 00:00:00"; //JUN-773 20220318
    jun.SOCIAL_PLUS_2ND_START = "2040-12-31 00:00:00"; //JUN-773 20220329
    jun.POINT_USE_RATIO = 1; //JUN-861 20220519
    jun.POINT_VER2_START_TIME_STAGE = "2022-06-13 09:34:00"; //JUN-861 20220613
    jun.POINT_VER2_START_TIME = "2022-09-21 00:00:00"; //JUN-861 20220613
    //会員ランクポイント倍率リスト
    //JUN-861 20220609
    jun.CST_RANK_MLTI_LIST_VER1 = {
        diamond: 10,
        platinum: 5,
        gold: 3,
        silver: 2,
        regular: 1,
        temporary: 1,
    };
    jun.CST_RANK_MLTI_LIST = {
        diamond: 15,
        platinum: 10,
        gold: 5,
        silver: 3,
        regular: 2,
        temporary: 2,
    };
    //会員ランクの日本語リスト
    jun.CST_RANK_JP = {
        diamond: "ダイアモンド",
        platinum: "プラチナ",
        gold: "ゴールド",
        silver: "シルバー",
        regular: "レギュラー",
        temporary: "仮登録",
    };
    // お届け時間の選択肢
    jun.DELIV_TIME_CHOICES = [
        "指定なし",
        "午前中",
        "14:00～16:00",
        "16:00～18:00",
        "18:00～20:00",
        "19:00～21:00",
    ];
    // 決済方法
    jun.GATE_WAYS = {
        other: "その他",
        external_credit: "クレジットカード決済",
        cash_on_delivery: "代金引換",
        external_rakuten: "楽天ペイ",
        external_docomo: "d払い決済",
        external_amazon_pay: "AmazonPay",
        external_paypay: "PayPay",
        external_paidy: "Paidy",
        external_smartpay: "Smartpay",
        external_paypal: "PayPal",
        external_aupay: "au PAY",
    };
    // カート画面で一度に注文可能な商品個数上限
    jun.MAX_QUANTITY = 10;
    // 送料無料対象金額（税込）
    jun.FREE_SHIPPING_PRICE = 3300;
    // 送料無料対象金額（税込）_ver2
    // export const FREE_SHIPPING_PRICE_VER2 = 5500;
    jun.FREE_SHIPPING_PRICE_VER2 = 0;
    jun.SHOPIFY_STOREFRONT_ACCESS_TOKEN = window.ENV_ACCESS_TOKEN;
    jun.CUSTOM_APP_URL = window.ENV_APP_URL;
    // backend（CUSTOM_APP_URL）の本人確認に失敗したときのエラーコード（ログインし直しが必要）
    jun.NOT_LOGGED_IN_ERROR_CODE = "AUT-005";
    // /api/point/get だけは本人確認の失敗を以前からこのコードで返す
    jun.POINT_GET_UNAUTHORIZED_CODE = "401";
    jun.NOT_LOGGED_IN_MESSAGE = "ログインの有効期限が切れました。再度ログインしてください。";
    jun.CMS_URL = window.ENV_CMS_URL;
    jun.GATE_WAY_CASH_ON_DELIV = window.ENV_COD;
    // GIDサイト情報
    jun.GID_EDIT_KEY = "gid_edit_path";
    jun.GID_HISTORY_KEY = "gid_history_path";
    jun.GID_INFO_KEY = "gid_info_path";
    jun.GID_UNSUBSCRIBE_KEY = "gid_unsubscribe_path";
    jun.GID_INDEX_URL = "https://www.junglobal-id.com/";
    jun.ERROR_CODE_FAILED_TO_CONVERT_FROM_GID_TO_SHOPIFY = "VLD-003";
    jun.ERROR_CODE_FAILED_TO_EMAIL_HAS_ALREADY_BEEN_TAKEN = "FAT-002";
    jun.RANK_THRESHOLD_DATE = 5;
    jun.YAPPLI_BROWSER = "yappli"; //20211110 JUN-662
    jun.QUALICA_COOKIE_GID = "qualica_gid"; //20211110 JUN-662
    jun.JOL_AC_CAT_NAME_PROD = "jol_ac_cat"; //20211110 JUN-662
    jun.JOL_AC_CAT_NAME_STG = "jol_ac_cat_test"; //20211110 JUN-662
    jun.JOL_AC_COID_NAME_PROD = "jol_ac_coid"; //20211110 JUN-662
    jun.JOL_AC_COID_NAME_STG = "jol_ac_coid_test"; //20211110 JUN-662
    jun.JOL_AC_COID_NAME = window.ENV_JOL_AC_COID_NAME;
    jun.STG_HOST_URL = "https://stg-app.junonline.jp"; //20211110 JUN-662
    jun.STG_CMS_URL = window.ENV_CMS_URL;
    jun.PROD_HOST_URL = "https://app.junonline.jp"; //20211110 JUN-662
    jun.PROD_CMS_URL = "https://www.junonline.jp"; //20211110 JUN-662
})(jun || (jun = {}));
var jun;
(function (jun) {
    var graphql;
    (function (graphql) {
        graphql.checkoutBase = `
      id
      appliedGiftCards {
        id
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
      }
      checkoutUrl
      cost {
        checkoutChargeAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }
      }
      discountAllocations {
        discountedAmount {
          amount
          currencyCode
        }
      }
      buyerIdentity {
        email
        phone
      }
      attributes {
        key
        value
      }
      lines(first: 110) {
        edges {
          node {
            id
            quantity
            discountAllocations {
              discountedAmount {
                amount
                currencyCode
              }
            }
            cost {
              amountPerQuantity {
                amount
              }
              compareAtAmountPerQuantity {
                amount
              }
              subtotalAmount {
                amount
              }
              totalAmount {
                amount
              }
            }
            attributes {
              key
              value
            }
            merchandise {
              ... on ProductVariant {
                id
                sku
                title
                compareAtPrice {
                  amount
                }
                price {
                  amount
                }
                image {
                  id
                  src: originalSrc
                  altText
                }
                selectedOptions {
                  name
                  value
                }
                reserveFlg: metafield(
                  namespace: "reserve_flg"
                  key: "reserve_flg"
                ) {
                  value
                }
                reserveDeliveryDate: metafield(
                  namespace: "reserve_delivery_dt"
                  key: "reserve_delivery_date"
                ) {
                  value
                }
                originalPrice: metafield(
                  namespace: "original_price"
                  key: "original_price"
                ) {
                  value
                }
                systemData: metafield(namespace: "system", key: "system_data") {
                  value
                }
                purchase_limit: metafield(
                  namespace: "jun"
                  key: "purchase_limit"
                ) {
                  value
                }
                product {
                  id
                  handle
                  tags
                  title
                  productCode: metafield(
                    namespace: "system"
                    key: "product_code"
                  ) {
                    value
                  }
                  purchase_limit: metafield(
                    namespace: "jun"
                    key: "purchase_limit"
                  ) {
                    value
                  }
                  codProhibited: metafield(
                    namespace: "jun"
                    key: "cod_prohibited"
                  ) {
                    value
                  }
                }
              }
            }
          }
        }
      }
  `;
        graphql.queryCheckout = `
  query ($id:ID!) {
    node: cart(id: $id) {
    ${graphql.checkoutBase}
    }
  }
  `;
        graphql.checkoutCreate = `
  mutation cartCreate {
    cartCreate {
      cart {
        ${graphql.checkoutBase}
      }
      userErrors {
        field
        message
      }
    }
  }
  `;
        graphql.queryProduct = `
        query ($codeQuery:String!) {
            products(first: 6, query: $codeQuery) {
                edges {
                    node {
                        id
                        title
                        tags
                        handle
                        vendor
                        productCode: metafield(namespace:"system", key:"product_code") {
                            value
                        }
                        variants (first: 1) {
                            edges {
                                node {
                                    id
                                    sku
                                    title
                                    price {
                                        amount
                                    }
                                    image {
                                        id
                                        src: originalSrc
                                        altText
                                    }
                                    originalPrice: metafield(namespace:"original_price", key:"original_price") {
                                        value
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
    })(graphql = jun.graphql || (jun.graphql = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var tpl;
    (function (tpl) {
        /**
        最近見た商品・おすすめ商品・ギフト商品処理
        */
        function itemArea(recentItem, isGiftItem = false) {
            let firstVariant = recentItem.variants.edges[0].node;
            if (firstVariant.image == null) {
                return jun.BLANK;
            }
            let productUrl = "javascript:void(0);";
            const productCode = recentItem.productCode;
            if (productCode != null) {
                productUrl = jun.CMS_URL + "/products/d/" + productCode.value;
            }
            let html = `
         <li class="c-block-3__item">
           <a href="${productUrl}" class="c-block-3__link">
             <div class="c-block-3__img">
               <img src="${firstVariant.image.src}" alt="${firstVariant.image.altText}">
             </div>
    `;
            if (!isGiftItem) {
                const vendor = recentItem.vendor;
                const brand = vendor.substr(vendor.indexOf("＞") + 1);
                const brandName = brand.substr(brand.indexOf(":") + 1);
                html += `
             <p class="c-block-3__brand">${brandName}</p>
      `;
            }
            html += `
             <p class="c-block-3__name">${recentItem.title}</p>
             <p class="c-block-3__price">¥${jun.FormatUtil.amt(parseInt(firstVariant.price.amount))}</p>
    `;
            let originalPrice = firstVariant.originalPrice;
            if (originalPrice != null) {
                originalPrice = Number(firstVariant.originalPrice.value);
            }
            if (originalPrice && originalPrice != firstVariant.price.amount) {
                const percent = jun.FormatUtil.amt(Math.round((1 - firstVariant.price.amount / originalPrice) * 100));
                html += `
         <p class="c-block-3__off">${percent}%OFF</p>
     `;
            }
            html += `
           </a>
         </li>
    `;
            return html;
        }
        tpl.itemArea = itemArea;
    })(tpl = jun.tpl || (jun.tpl = {}));
})(jun || (jun = {}));
/// <reference path="../../library/jquery/index.d.ts" />
/// <reference path="../../library/jqueryui/index.d.ts" />
/// <reference path="../../library/b-dash/recommend.d.ts" />
/// <reference path="./storefront.ts" />
/// <reference path="./const.ts" />
/// <reference path="./interface.ts" />
/// <reference path="./graphql.ts" />
/// <reference path="./tpl.ts" />
var jun;
(function (jun) {
    class AbstractApplication {
    }
    jun.AbstractApplication = AbstractApplication;
    async function ready(app) {
        TrackingUtil.appendImg({ debug_step: "ready-start" });
        app.display();
        //会員ランク表示
        HeaderMenuUtil.addCustomerRank();
        await jun.CheckoutUtil.initCheckoutData();
        // トラッキング用画像を追加
        TrackingUtil.appendImg({ debug_step: "ready-after-initCheckoutData" });
        //JUN-662 20211109
        let skipCtrl = false;
        readYappliCss();
        if (isYappli()) {
            let member_id = $("#tag-data-holder-common").data("gid");
            if (member_id == undefined || $.trim(member_id) == "") {
                const params = new URLSearchParams(window.location.search);
                const error_code = params.get("error_code");
                if (error_code != null && error_code != "") {
                    document.cookie = jun.QUALICA_COOKIE_GID + `=; max-age=0; path=/;`;
                }
                let jol_ac_cat_name = jun.JOL_AC_CAT_NAME_STG;
                if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                    jol_ac_cat_name = jun.JOL_AC_CAT_NAME_PROD;
                }
                let cookieArr = getCookieArray();
                let isloginQualicaGid = jun.QUALICA_COOKIE_GID in cookieArr; //開発環境の考慮
                if (jun.CUSTOM_APP_URL === jun.STG_HOST_URL ||
                    jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                    isloginQualicaGid =
                        jol_ac_cat_name in cookieArr && jun.QUALICA_COOKIE_GID in cookieArr;
                }
                if (isloginQualicaGid) {
                    jun.MaskUtil.addMask();
                    skipCtrl = true;
                    loginQualicaGid(cookieArr[jun.QUALICA_COOKIE_GID]);
                }
            }
        }
        //JUN-662 20211109
        if (!skipCtrl) {
            //checkoutに登録されている商品数を取得して表示
            jun.HeaderMenuUtil.addCartItems();
            //会員保持ポイント表示
            // api同時実行抑制
            const sleep = (time) => new Promise((r) => setTimeout(r, time));
            (async function () {
                for (let i = 0; i < 10; i++) {
                    if (jun.is_calling_api_point_get()) {
                        await sleep(100 * 2 ** i);
                        continue;
                    }
                    break;
                }
                HeaderMenuUtil.addHoldPoint();
            })();
            // 登録内容変更リンク作成
            HeaderMenuUtil.transGidEdit();
            app.init();
        }
        TrackingUtil.appendImg({ debug_step: "ready-end" });
    }
    jun.ready = ready;
    async function checkoutReady(app) {
        try {
            TrackingUtil.appendImg({ debug_step: "checkout-ready-start" });
            let dispResult = app.display(); //20211224 JUN-774
            TrackingUtil.appendImg({ debug_step: "checkout-ready-after-display" });
            await jun.CheckoutUtil.initCheckoutData();
            // トラッキング用画像を追加
            TrackingUtil.appendImg({
                debug_step: "checkout-ready-after-initCheckoutData",
            });
            //JUN-662 20211109
            readYappliCss();
            if (isYappli() && dispResult === undefined) {
                //20211224 JUN-774
                let member_id = $("#tag-data-holder-checkout-order").data("gid");
                if (member_id == undefined || $.trim(member_id) === "") {
                    const params = new URLSearchParams(window.location.search);
                    const error_code = params.get("error_code");
                    if (error_code != null && error_code != "") {
                        document.cookie = jun.QUALICA_COOKIE_GID + `=; max-age=0; path=/;`;
                    }
                    let jol_ac_cat_name = jun.JOL_AC_CAT_NAME_STG;
                    if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                        jol_ac_cat_name = jun.JOL_AC_CAT_NAME_PROD;
                    }
                    let cookieArr = getCookieArray();
                    let isloginQualicaGid = jun.QUALICA_COOKIE_GID in cookieArr; //開発環境の考慮
                    if (jun.CUSTOM_APP_URL === jun.STG_HOST_URL ||
                        jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                        isloginQualicaGid =
                            jol_ac_cat_name in cookieArr && jun.QUALICA_COOKIE_GID in cookieArr;
                    }
                    if (isloginQualicaGid) {
                        jun.MaskUtil.addMask();
                        loginQualicaGid(cookieArr[jun.QUALICA_COOKIE_GID]);
                    }
                }
            }
            app.init();
            TrackingUtil.appendImg({ debug_step: "checkout-ready-end-ok" });
        }
        catch (e) {
            TrackingUtil.appendImg({ debug_step: "checkout-ready-end-error" });
            // await Logger.error({
            //     message: e.name +': '+ e.message,
            // });
            // alert('予期せぬエラーが発生したので、TOP画面に戻ります。')
            // window.location.href = CMS_URL;
        }
    }
    jun.checkoutReady = checkoutReady;
    function isDefined(obj) {
        var type = $.type(obj);
        return type !== "null" && type !== "undefined";
    }
    jun.isDefined = isDefined;
    function isBoolean(obj) {
        return $.type(obj) === "boolean";
    }
    jun.isBoolean = isBoolean;
    function isNumber(obj) {
        return $.type(obj) === "number";
    }
    jun.isNumber = isNumber;
    function isString(obj) {
        return $.type(obj) === "string";
    }
    jun.isString = isString;
    function isEmpty(obj) {
        return jun.StringUtil.isEmpty(obj);
    }
    jun.isEmpty = isEmpty;
    function isObject(obj) {
        return $.isPlainObject(obj);
    }
    jun.isObject = isObject;
    function isArray(obj) {
        return $.type(obj) === "array";
    }
    jun.isArray = isArray;
    function isMobile() {
        return navigator.userAgent.match(/iPhone|Android.+Mobile/) !== null;
    }
    jun.isMobile = isMobile;
    /**
     * カート単位の割引額の合計を取得
     */
    function getCartDiscountTotal() {
        const checkout = jun.CheckoutUtil.getCheckoutData();
        const allocations = checkout.discountAllocations;
        if (!isDefined(allocations)) {
            return 0;
        }
        let total = 0;
        for (const allocation of allocations) {
            total += Number(allocation.discountedAmount.amount);
        }
        return total;
    }
    jun.getCartDiscountTotal = getCartDiscountTotal;
    /**
     * 税率別の課税対象額を取得
     * カート単位の割引は税率グループの金額比で按分する
     */
    function getTaxableAmountByRate() {
        const checkout = jun.CheckoutUtil.getCheckoutData();
        let taxable = {};
        taxable[jun.TAX_RATE_NML] = 0;
        taxable[jun.TAX_RATE_RDC] = 0;
        let sumLineTotal = 0;
        for (const edge of checkout.lines.edges) {
            const lineTotal = Number(edge.node.cost.totalAmount.amount);
            taxable[getCommonTaxRate(edge.node)] += lineTotal;
            sumLineTotal += lineTotal;
        }
        const cartDiscount = getCartDiscountTotal();
        if (cartDiscount <= 0 || sumLineTotal <= 0) {
            return taxable;
        }
        for (const rate of [jun.TAX_RATE_NML, jun.TAX_RATE_RDC]) {
            taxable[rate] -= Math.round((cartDiscount * taxable[rate]) / sumLineTotal);
        }
        return taxable;
    }
    jun.getTaxableAmountByRate = getTaxableAmountByRate;
    /**
     * //JUN-861 20220519
     * checkoutに登録されている商品の税込合計金額を取得
     */
    function getTotalAmountLineItems() {
        const checkout = jun.CheckoutUtil.getCheckoutData();
        const subTotal = Number(checkout.cost.subtotalAmount.amount);
        const taxable = getTaxableAmountByRate();
        let tax = 0;
        for (const rate of [jun.TAX_RATE_NML, jun.TAX_RATE_RDC]) {
            tax += Math.round(taxable[rate] * rate);
        }
        return Math.round(subTotal - getCartDiscountTotal() + tax);
    }
    jun.getTotalAmountLineItems = getTotalAmountLineItems;
    /**
     * 明細の実効単価を取得
     * 割引適用後の明細合計を数量で割った額
     */
    function getLineUnitPrice(lineItem) {
        if (lineItem.quantity <= 0) {
            return 0;
        }
        return Math.round(Number(lineItem.cost.totalAmount.amount) / lineItem.quantity);
    }
    jun.getLineUnitPrice = getLineUnitPrice;
    /**
     * //JUN-861 20220519
     * 税率を取得
     */
    function getCommonTaxRate(lineItem) {
        const tags = lineItem.merchandise.product.tags;
        let taxRate;
        if ($.inArray(jun.TAG_RDC_TAX, tags) == -1) {
            taxRate = jun.TAX_RATE_NML;
        }
        else {
            taxRate = jun.TAX_RATE_RDC;
        }
        return taxRate;
    }
    jun.getCommonTaxRate = getCommonTaxRate;
    //JUN-796 20220530
    function isBase64(str) {
        if (str === "" || str.trim() === "") {
            return false;
        }
        try {
            return btoa(atob(str)) == str;
        }
        catch (err) {
            return false;
        }
    }
    jun.isBase64 = isBase64;
    //JUN-662 20211110
    //Yappliの判定
    function isYappli() {
        let browserName = jun.YAPPLI_BROWSER;
        let is_yappli = false;
        if ("userAgent" in navigator) {
            if (navigator.userAgent.toLowerCase().indexOf(browserName) !== -1) {
                is_yappli = true;
            }
        }
        else {
            if ("userAgentData" in navigator) {
                let brands = navigator.userAgentData.brands;
                for (let i = 0; i < brands.length; i++) {
                    if (brands[i]["brand"].toLowerCase().indexOf(browserName) !== -1) {
                        is_yappli = true;
                        break;
                    }
                }
            }
        }
        return is_yappli;
    }
    jun.isYappli = isYappli;
    //JUN-662 20211110
    //クッキー値の取得
    function getCookieArray() {
        let result = {};
        let cookies = document.cookie;
        let cookiesArray = cookies.split(";");
        for (let i = 0; i < cookiesArray.length; i++) {
            let cArray = $.trim(cookiesArray[i]).split("=");
            let cookieValue = "";
            for (let n = 1; n < cArray.length; n++) {
                if (n > 1) {
                    cookieValue += "=";
                }
                cookieValue += $.trim(cArray[n]);
            }
            result[$.trim(cArray[0])] = cookieValue;
        }
        return result;
    }
    jun.getCookieArray = getCookieArray;
    //JUN-662 20211110
    //Yappliログイン
    function loginQualicaGid(qualicaGid) {
        if (qualicaGid === undefined || qualicaGid === "") {
            return false;
        }
        let returnUrlAfterYappliLogin = null;
        const params = new URLSearchParams(window.location.search);
        returnUrlAfterYappliLogin = location.href;
        let form = document.createElement("form");
        const url = jun.CUSTOM_APP_URL + "/api/customer/yappli_login";
        form.method = "post";
        form.action = url;
        form.innerHTML = '<input name="qualicaGid" value=' + qualicaGid + ">";
        form.innerHTML +=
            '<input name="return_to" value=' + returnUrlAfterYappliLogin + ">";
        document.body.append(form);
        form.submit();
    }
    jun.loginQualicaGid = loginQualicaGid;
    //JUN-662 20211110
    //Yappli用のCSSの読み込み
    function readYappliCss() {
        if (isYappli()) {
            let css_links = document.getElementsByTagName("link");
            let target_links = [];
            let target_link = "";
            let target_vparams = [];
            let target_vparam = "";
            if (css_links.length > 0) {
                //cdnリンクを他タグから取得
                for (let i = 0; i < css_links.length; i++) {
                    if (css_links[i].href.indexOf("loader.css") !== -1) {
                        target_links = css_links[i].href.split("loader.css");
                        target_link = target_links[0].replace(/https:/g, "");
                        if (target_links[1].indexOf("=") !== -1) {
                            target_vparams = target_links[1].split("=");
                            target_vparam = target_vparams[1];
                        }
                        break;
                    }
                }
                if (target_vparam != "") {
                    target_vparam = "?ver=1.0.1";
                }
                let link = document.createElement("link");
                link.href = target_link + "yappli.css" + target_vparam;
                link.rel = "stylesheet";
                link.type = "text/css";
                link.media = "all";
                let header = document.getElementsByTagName("head")[0];
                header.appendChild(link);
                $("body").addClass("yappli");
            }
        }
    }
    jun.readYappliCss = readYappliCss;
    //JUN-662 20211110
    //checkout_idの取得
    function getCookieCheckOutId() {
        let checkout_id = "";
        let cookieArr = getCookieArray();
        let jol_ac_coid_name = jun.JOL_AC_COID_NAME_STG;
        if (jun.JOL_AC_COID_NAME) {
            jol_ac_coid_name = jun.JOL_AC_COID_NAME;
        }
        if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
            jol_ac_coid_name = jun.JOL_AC_COID_NAME_PROD;
        }
        let jol_ac_coid_obj = {};
        if (jol_ac_coid_name in cookieArr) {
            if (cookieArr[jol_ac_coid_name] != "") {
                let jol_ac_coid_obj_str = decodeURIComponent(cookieArr[jol_ac_coid_name]);
                jol_ac_coid_obj = JSON.parse(jol_ac_coid_obj_str);
                checkout_id = jol_ac_coid_obj["id"];
            }
        }
        //空の場合リダイレクト
        if (checkout_id === "") {
            let create_checkout_id_url = jun.STG_CMS_URL + "/cart/generateback?return_to=";
            if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                create_checkout_id_url = jun.PROD_CMS_URL + "/cart/generateback?return_to=";
            }
            window.location.href = create_checkout_id_url + location.href;
        }
        return checkout_id;
    }
    jun.getCookieCheckOutId = getCookieCheckOutId;
    /**
     * 20211221 JUN-752
     * 日本時間で現在日時のDateを返却
     * @returns
     */
    function getNowDateTime() {
        // 協定世界時の文字列を取得
        const date = new Date();
        const utc = date.toUTCString();
        // 取得された文字列の「GMT」を除去する
        const g_replace = utc.replace("GMT", "");
        // 除去された文字列を使用し、インスタンスする
        const gDate = new Date(g_replace);
        const hours = gDate.getHours();
        gDate.setHours(hours + 9);
        return gDate;
    }
    jun.getNowDateTime = getNowDateTime;
    /**
     * 20211221 JUN-752
     * 引き渡した時間の期間判定
     * @returns
     */
    function isBetWeenTerm(from_date_str, to_date_str) {
        from_date_str = from_date_str.replace(/[-]/g, "/");
        to_date_str = to_date_str.replace(/[-]/g, "/");
        let from_date = new Date(from_date_str);
        let to_date = new Date(to_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime() &&
            getNowDateTime().getTime() < to_date.getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    jun.isBetWeenTerm = isBetWeenTerm;
    /**
     * 20220318 JUN-773
     * ソーシャルプラス洗い替え後の分岐
     * @returns
     */
    function get_social_plus_ver() {
        const from_date_str = jun.SOCIAL_PLUS_VER2_START.replace(/[-]/g, "/");
        let from_date = new Date(from_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime()) {
            return 2;
        }
        else {
            return 1;
        }
    }
    jun.get_social_plus_ver = get_social_plus_ver;
    /**
     * JUN-861 20220613
     * 1pt1円対応の分岐
     * @returns
     */
    function get_point_ver_2nd() {
        let from_date_str = jun.POINT_VER2_START_TIME_STAGE.replace(/[-]/g, "/");
        if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
            from_date_str = jun.POINT_VER2_START_TIME.replace(/[-]/g, "/");
        }
        let from_date = new Date(from_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    jun.get_point_ver_2nd = get_point_ver_2nd;
    /**
     * JUN-861 20220613
     * 1pt1円対応の分岐
     * @returns
     */
    function get_point_ratio() {
        if (get_point_ver_2nd()) {
            return jun.POINT_USE_RATIO;
        }
        else {
            return 2;
        }
    }
    jun.get_point_ratio = get_point_ratio;
    /**
     * JUN-861 20220613
     * 1pt1円対応の送料無料条件の取得
     * @returns
     */
    function get_free_shipping_price() {
        let free_shipping_price = jun.FREE_SHIPPING_PRICE;
        if (get_point_ver_2nd()) {
            free_shipping_price = jun.FREE_SHIPPING_PRICE_VER2;
        }
        return free_shipping_price;
    }
    jun.get_free_shipping_price = get_free_shipping_price;
    /**
     * 20220329 JUN-773
     * ソーシャルプラス2ndフェーズの分岐
     * @returns
     */
    function get_social_plus_ver_2nd() {
        const from_date_str = jun.SOCIAL_PLUS_2ND_START.replace(/[-]/g, "/");
        let from_date = new Date(from_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    jun.get_social_plus_ver_2nd = get_social_plus_ver_2nd;
    function is_calling_api_point_get() {
        const s = sessionStorage.getItem("calling_api_point_get");
        return s != null;
    }
    jun.is_calling_api_point_get = is_calling_api_point_get;
    function set_calling_api_point_get() {
        sessionStorage.setItem("calling_api_point_get", "calling");
    }
    jun.set_calling_api_point_get = set_calling_api_point_get;
    function remove_calling_api_point_get() {
        sessionStorage.removeItem("calling_api_point_get");
    }
    jun.remove_calling_api_point_get = remove_calling_api_point_get;
    class FetchUtil {
        constructor() {
            throw new Error("FetchUtilはnewできません。");
        }
        static async fetch(resource, init, success, goToCart = false, loadMask = true) {
            if (loadMask) {
                jun.MaskUtil.addMask();
            }
            const res = await fetch(resource, init);
            try {
                const data = await this.handleErrorPrepare(res);
                success(data);
            }
            catch (err) {
                goToCart ? this.goToCart(res) : this.onError(res);
            }
            finally {
                if (loadMask) {
                    jun.MaskUtil.removeMask();
                }
            }
        }
        static async handleErrorPrepare(res) {
            // 5xx系エラーのときにはエラー扱い
            if (res.status.toString().charAt(0) == "5") {
                throw new Error();
            }
            return res.json();
        }
        static onError(res) {
            if (!jun.isDefined(res)) {
                return;
            }
            const message = "予期せぬエラーが発生しました。しばらく時間をおいて再度お試しください。";
            alert(message);
            throw new Error(message);
        }
        static goToCart(res) {
            alert("予期せぬエラーが発生しました。カート画面に遷移します。");
            window.location.href = jun.CART_URL;
        }
    }
    jun.FetchUtil = FetchUtil;
    class StringUtil {
        constructor() {
            throw new Error("StringUtilはnewできません。");
        }
        static isEmpty(text) {
            if (!jun.isString(text) || text.length == 0) {
                return true;
            }
            return false;
        }
        static isNotEmpty(text) {
            return !jun.StringUtil.isEmpty(text);
        }
        static htmlEncode(text) {
            if (isEmpty(text))
                return jun.BLANK;
            var holders = this.htmlSpecialCharsPlaceHolders;
            for (var i = 0, len = holders.length; i < len; i++) {
                var holder = holders[i];
                var regexp = new RegExp(holder[0], "g");
                text = text.replace(regexp, holder[1]);
            }
            return text;
        }
        static htmlDecode(text) {
            if (isEmpty(text))
                return jun.BLANK;
            var holders = this.htmlSpecialCharsPlaceHolders;
            for (var i = holders.length - 1; 0 <= i; i--) {
                var holder = holders[i];
                var regexp = new RegExp(holder[1], "g");
                text = text.replace(regexp, holder[0]);
            }
            return text;
        }
        static nl2br(value) {
            if (isEmpty(value))
                return jun.BLANK;
            return value.replace(/\r?\n/g, "<br/>");
        }
        static singleByteCharacters(text) {
            let length = 0;
            for (var i = 0; i < text.length; i++) {
                var c = text.charCodeAt(i);
                if ((c >= 0x0 && c < 0x81) ||
                    c === 0xf8f0 ||
                    (c >= 0xff61 && c < 0xffa0) ||
                    (c >= 0xf8f1 && c < 0xf8f4)) {
                    length += 1;
                }
                else {
                    length += 2;
                }
            }
            return length;
        }
        /**
         * 対象文字列の「%d」を置換する
         */
        static replaceFormat(target, value) {
            return target.replace(new RegExp("%d"), value);
        }
        /**
         * nullかundefindならBLANKに変換する
         * @param val 対象文字列
         */
        static convertNullToBlank(val) {
            return val !== null && val !== undefined ? val : jun.BLANK;
        }
        /**
         * nullかundefindならBLANKに変換する
         * @param object 対象オブジェクト
         * @param convertTargetList 項目名のリスト
         */
        static convertNullToBlankObjectPart(object, convertTargetList) {
            for (let convertTarget of convertTargetList) {
                object[convertTarget] = this.convertNullToBlank(object[convertTarget]);
            }
        }
    }
    StringUtil.htmlSpecialCharsPlaceHolders = [
        ["&", "&amp;"],
        ["<", "&lt;"],
        [">", "&gt;"],
        ["\r", "&#13;"],
        ["\n", "&#10;"],
        ['"', "&quot;"],
        ["'", "&#39;"],
    ];
    jun.StringUtil = StringUtil;
    class FormatUtil {
        /**
         * 数値を整数に変換、数値以外はエラーを返却
         */
        static changeInteger(value) {
            if (!jun.isDefined(value)) {
                return jun.BLANK;
            }
            const num_value = Number(value);
            return String(Math.trunc(num_value));
        }
        /**
         * 全角を半角に変換
         */
        static is_hankaku_number(value) {
            if (value.match(/^[0-9]+$/)) {
                return true;
            }
            return false;
        }
        /**
         * 全角を半角に変換
         */
        static hankaku2Zenkaku(value) {
            return value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
                return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
            });
        }
        /**
         * 数値を金額形式（3桁カンマ区切り）に変換
         */
        static amt(value, mark = false) {
            if (!jun.isDefined(value)) {
                return jun.BLANK;
            }
            let ret = String(value).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
            if (mark) {
                ret = "\xA5" + ret;
            }
            return ret;
        }
        /**
         * 金額形式（3桁カンマ区切り）を数値に変換
         */
        static amtDelSign(value) {
            if (jun.isEmpty(value)) {
                return null;
            }
            //円マークを除去
            value = $.trim(value).replace(/\xA5/g, jun.BLANK);
            return Number(value.replace(/,/g, jun.BLANK));
        }
        /**
         * 県コードを数値のみに変換
         */
        static getPrefId(value) {
            if (jun.isEmpty(value)) {
                return null;
            }
            const arr = value.split("-");
            if (!jun.isDefined(arr) || arr.length < 2) {
                return null;
            }
            return Number($.trim(arr[1]));
        }
        /**
         * string型の日付を変換して「YYYY年M月DD日 HH:MM」に変換
         */
        static getDateFormat(value, isHourAndTime = true) {
            const date = new Date(value);
            if (Number.isNaN(date.getFullYear())) {
                return jun.HYPHEN;
            }
            let ret = String(date.getFullYear()) +
                "年" +
                String(date.getMonth() + 1) +
                "月" +
                String(date.getDate()) +
                "日";
            if (isHourAndTime) {
                ret +=
                    jun.HALF_SPACE +
                        String(("0" + date.getHours()).slice(-2)) +
                        ":" +
                        String(("0" + date.getMinutes()).slice(-2));
            }
            return ret;
        }
        /**
         * string型の日付を変換して「YYYY年M月〇旬」に変換
         */
        static getDateFormat4Season(value) {
            let ret = jun.BLANK;
            const date = new Date(value);
            if (Number.isNaN(date.getFullYear())) {
                return ret;
            }
            const day = date.getDate();
            let season = jun.BLANK;
            switch (true) {
                case day <= 10:
                    season = "上旬";
                    break;
                case day <= 20:
                    season = "中旬";
                    break;
                default:
                    season = "下旬";
            }
            ret =
                String(date.getFullYear()) +
                    "年" +
                    String(date.getMonth() + 1) +
                    "月" +
                    season;
            return ret;
        }
    }
    jun.FormatUtil = FormatUtil;
    class MaskUtil {
        static addMask() {
            if (jun.MaskUtil.maskCount == 0) {
                $("body").addClass("loading");
            }
            jun.MaskUtil.maskCount++;
        }
        static removeMask() {
            if (jun.MaskUtil.maskCount == 0) {
                return;
            }
            jun.MaskUtil.maskCount--;
            if (jun.MaskUtil.maskCount == 0) {
                $("body").removeClass("loading");
            }
        }
    }
    MaskUtil.maskCount = 0;
    jun.MaskUtil = MaskUtil;
    class CheckoutUtil {
        static async initCheckoutData() {
            TrackingUtil.appendImg({ debug_step: "function-initCheckoutData-start" });
            const url = new URL(window.location.href);
            //JUN-662 20211109
            let checkout_id = "";
            if (jun.CUSTOM_APP_URL === jun.STG_HOST_URL || jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                checkout_id = getCookieCheckOutId();
            }
            else if (jun.JOL_AC_COID_NAME) {
                checkout_id = getCookieCheckOutId();
            }
            else {
                checkout_id = url.searchParams.get("id"); //開発環境の考慮
            }
            if (checkout_id != null) {
                localStorage.setItem("checkout_id", checkout_id);
            }
            checkout_id = localStorage.getItem("checkout_id");
            if (checkout_id != null &&
                checkout_id.indexOf("gid://shopify/Cart/") !== 0) {
                checkout_id = "";
            }
            if (checkout_id != null && checkout_id != "") {
                await jun.CheckoutUtil.fetchCheckout(checkout_id);
                //注文完了済でなければ、処理を終了
                if (!jun.CheckoutUtil.isCompleted) {
                    TrackingUtil.appendImg({
                        debug_step: "function-initCheckoutData-end-ok",
                    });
                    return;
                }
            }
            // checkoutを作成
            TrackingUtil.appendImg({
                debug_step: "function-initCheckoutData-create-checkout-start",
            });
            await jun.CheckoutUtil.createCheckout();
            TrackingUtil.appendImg({
                debug_step: "function-initCheckoutData-create-checkout-end",
            });
        }
        //JUN-1149 22020914
        /**
         * checkoutをリフレッシュ
         */
        static async refreshCheckoutData() {
            const checkout_id = localStorage.getItem("checkout_id");
            if (checkout_id != null && checkout_id != "") {
                await jun.CheckoutUtil.fetchCheckout(checkout_id);
                return jun.CheckoutUtil.getCheckoutData();
            }
            return null;
        }
        //JUN-1149 22020914
        /**
         * checkoutからギフトカード情報を抜き出す
         */
        static getApplyGiftData(cart) {
            if (cart.appliedGiftCards[0] != undefined) {
                return cart.appliedGiftCards[0];
            }
            return null;
        }
        //JUN-1149 22020914
        /**
         * attributesの使用ポイントとチェックアウト情報のギフトカード金額の比較
         */
        static async isCheckUsePoint() {
            let checkout = await jun.CheckoutUtil.refreshCheckoutData();
            let giftCard = jun.CheckoutUtil.getApplyGiftData(checkout);
            let usePointValue = 0;
            let giftCardValue = 0;
            let usePoint = null;
            if (checkout.attributes != undefined) {
                usePoint = checkout.attributes.find((item) => {
                    return item.key === jun.ATTR_USE_POINT_KEY;
                });
                if (usePoint != null &&
                    usePoint != undefined &&
                    usePoint.value != undefined) {
                    usePointValue = Number(usePoint.value);
                }
            }
            if (giftCard !== null && giftCard.id != undefined && giftCard.id != "") {
                giftCardValue = Number(giftCard.balance.amount);
            }
            //console.log(usePointValue);
            //console.log(giftCardValue);
            if (usePointValue != giftCardValue) {
                return false;
            }
            return true;
        }
        static getCheckoutData() {
            const data = jun.CheckoutUtil.checkoutData;
            if (data == null) {
                throw new Error("先にinitCheckoutDataを行ってください。");
            }
            return data;
        }
        static setCheckoutData(cart) {
            if (cart == null) {
                throw new Error("データがありません。");
            }
            jun.CheckoutUtil.checkoutData = cart;
        }
        static buildPurchaseLimit(lineItemsEdges) {
            const hinbans = {};
            const skus = {};
            const purchaseLimit = {
                hinbans: hinbans,
                skus: skus,
            };
            for (const edge of lineItemsEdges) {
                const lineItem = edge.node;
                const hinban = lineItem.merchandise.product.handle;
                const sku = lineItem.merchandise.sku;
                if (lineItem.merchandise.product.purchase_limit) {
                    purchaseLimit.hinbans[hinban] =
                        lineItem.merchandise.product.purchase_limit.value;
                }
                if (lineItem.merchandise.purchase_limit) {
                    purchaseLimit.skus[sku] = lineItem.merchandise.purchase_limit.value;
                }
            }
            return purchaseLimit;
        }
        /**
         * checkoutをfetch
         */
        static async fetchCheckout(checkout_id) {
            const params = {
                query: jun.graphql.queryCheckout,
                variables: { id: checkout_id },
            };
            await jun.storefront.exeStoreFront(params, (obj) => {
                if (obj.errors) {
                    alert("予期せぬエラーが発生したのでカート画面に戻ります。");
                    location.href = jun.CMS_URL;
                    return;
                }
                const cart = obj.data.node;
                jun.CheckoutUtil.checkoutData = cart;
                jun.CheckoutUtil.isCompleted = cart == null;
            });
        }
        /**
         * checkoutを作成
         */
        static async createCheckout() {
            const params = {
                query: jun.graphql.checkoutCreate,
                variables: {},
            };
            let cart = null;
            while (this.retryIdleTime < 100) {
                //初回はsleepしない
                if (this.retryIdleTime != 1) {
                    await this.sleep(this.retryIdleTime);
                }
                await jun.storefront.exeStoreFront(params, (obj) => {
                    if (obj.errors) {
                        jun.CheckoutUtil.retryIdleTime *= 2;
                    }
                    else {
                        cart = obj.data.cartCreate.cart;
                    }
                });
                if (cart != null) {
                    break;
                }
            }
            if (cart == null || this.retryIdleTime > 100) {
                const message = "予期せぬエラーが発生しました。しばらく時間をおいて再度お試しください。";
                alert(message);
                throw new Error(message);
            }
            jun.CheckoutUtil.checkoutData = cart;
            localStorage.setItem("checkout_id", cart.id);
        }
        /**
         * checkoutに登録されている商品数を取得
         */
        static getCheckoutLineItems() {
            const cart = jun.CheckoutUtil.getCheckoutData();
            const lines = cart.lines.edges;
            let count = 0;
            for (const line of lines) {
                const quantity = line.node.quantity;
                count += quantity;
            }
            return count;
        }
        static hasReservedItem() {
            return jun.CheckoutUtil.getReservedItems().length > 0;
        }
        static getReservedItems() {
            const checkout = jun.CheckoutUtil.getCheckoutData();
            const lineItems = checkout.lineItems.edges;
            return lineItems.filter((item) => {
                return item.node.merchandise.reserveFlg !== "FALSE";
            });
        }
        static sleepEnd() {
            jun.MaskUtil.removeMask();
        }
        static async sleepStart(sec) {
            jun.MaskUtil.addMask();
            return new Promise((resolve) => setTimeout(resolve, sec * 1000));
        }
        static async sleep(sec) {
            await this.sleepStart(sec);
            this.sleepEnd();
        }
    }
    CheckoutUtil.checkoutData = null;
    CheckoutUtil.isCompleted = false;
    CheckoutUtil.retryIdleTime = 1;
    jun.CheckoutUtil = CheckoutUtil;
    class TagsUtil {
        static isGiftProduct(tags) {
            if (tags.length == 0) {
                return false;
            }
            return tags.includes(jun.PRD_GFT);
        }
        static isReduceTax(tags) {
            if (tags.length == 0) {
                return false;
            }
            return tags.includes(jun.TAG_RDC_TAX);
        }
        static getLocation(tags) {
            let ret = [];
            for (const tag of tags) {
                if (tag == jun.LOC_FBZ || tag == jun.LOC_DST) {
                    ret.push(tag);
                }
            }
            return ret;
        }
        static getCustomerRank(tags) {
            let ret = jun.BLANK;
            //JUN-861 20220613
            let cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST;
            if (!get_point_ver_2nd()) {
                cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST_VER1;
            }
            const rankList = Object.keys(cst_rank_mlti_list);
            for (const tag of tags) {
                for (const rank of rankList) {
                    if (tag == rank) {
                        ret = tag;
                        break;
                    }
                }
                if (ret != jun.BLANK) {
                    break;
                }
            }
            return ret;
        }
        static isOutletProduct(tags) {
            let match_tag = "outlet";
            if (tags.length == 0) {
                return false;
            }
            return tags.includes(match_tag);
        }
    }
    jun.TagsUtil = TagsUtil;
    class HeaderMenuUtil {
        static addCustomerRank() {
            const customerTags = $("[data-customerTags]").data("customerTags");
            if (customerTags == undefined) {
                return;
            }
            const customerRank = jun.TagsUtil.getCustomerRank(customerTags);
            const customerRankJp = jun.CST_RANK_JP[customerRank];
            $("[data-customer-rank]").text(customerRankJp);
            if (customerRank == "temporary") {
                $(".display_for_temporary").show();
            }
        }
        // 所持ポイントを表示
        static addHoldPoint() {
            jun.set_calling_api_point_get();
            const checkout = jun.CheckoutUtil.getCheckoutData();
            const shopifyCustomerId = $("[data-shopify-customer-id-for-header]").data("shopify-customer-id-for-header");
            if (shopifyCustomerId == undefined) {
                jun.remove_calling_api_point_get();
                return;
            }
            const init = {
                method: "get",
                mode: "cors",
                credentials: "include",
            };
            const param = "shopify_customer_id=" +
                shopifyCustomerId +
                "&checkout_id=" +
                checkout.id;
            const url = jun.CUSTOM_APP_URL + "/api/point/get?" + param;
            FetchUtil.fetch(url, init, (res) => {
                if (jun.isDefined(res.error.code)) {
                    if (res.error.code === jun.POINT_GET_UNAUTHORIZED_CODE) {
                        HeaderMenuUtil.notLoggedIn = true;
                    }
                    if (jun.isDefined(res.error.message)) {
                        console.log(res.error.message);
                        // alert(res.error.message);
                    }
                    jun.remove_calling_api_point_get();
                    return;
                }
                // 所持ポイント表示
                $("[data-hold-point]").text(jun.FormatUtil.amt(res.data.point));
                // ポイント有効期限表示
                const expireDate = res.data.expire_date;
                let expireString = jun.HYPHEN;
                if (expireDate != jun.BLANK) {
                    expireString =
                        expireDate.substr(0, 4) +
                            "/" +
                            Number(expireDate.substr(4, 2)) +
                            "/" +
                            Number(expireDate.substr(6, 2));
                }
                $("[data-point-expire]").text(expireString);
                jun.remove_calling_api_point_get();
            }, false, false);
        }
        /**
         * カート投入件数を表示
         */
        static addCartItems() {
            const count = jun.CheckoutUtil.getCheckoutLineItems();
            $("[data-cart-item-count]").text(count);
        }
        static transGidEdit() {
            $("[data-gidsite-change]").on("click", function () {
                HeaderMenuUtil.transGidSite(jun.GID_EDIT_KEY);
            });
        }
        /**
         * GID会員サイトへ遷移
         */
        static async transGidSite(gidPath) {
            // 本人確認に失敗済みなら、新しいタブを開く前にここで案内する
            // （タブを開いた後だと、裏に回った元のタブの alert が表示されないことがある）
            if (HeaderMenuUtil.notLoggedIn) {
                alert(jun.NOT_LOGGED_IN_MESSAGE);
                location.href = "/account/login";
                return;
            }
            const gid = $("[data-gid-for-header]").data("gid-for-header");
            const init = {
                method: "get",
                mode: "cors",
                // backend はログイン時に発行した Cookie で本人確認する
                credentials: "include",
            };
            const param = "qualica_gid=" + gid + "&trans_path=" + gidPath;
            const url = jun.CUSTOM_APP_URL + "/api/transGidView?" + param;
            //ポップアップブロックを防ぐため、先にwindow.openする
            const newTab = window.open("", "_blank");
            await FetchUtil.fetch(url, init, (res) => {
                if (jun.isDefined(res.error.code)) {
                    if (newTab != null) {
                        newTab.close();
                    }
                    alert(res.error.message);
                    if (res.error.code === jun.NOT_LOGGED_IN_ERROR_CODE) {
                        location.href = "/account/login";
                    }
                    return;
                }
                const redirectPath = res.data.redirectPath;
                if (newTab != null) {
                    newTab.location.href = redirectPath;
                }
                // location.href = redirectPath;
                // window.open(redirectPath, '_blank');
            });
        }
    }
    // 所持ポイント取得（ページ読み込み時）で backend の本人確認に失敗したか。
    // GID会員サイトへの遷移前に見て、新しいタブを開かずにログインし直しを促す
    HeaderMenuUtil.notLoggedIn = false;
    jun.HeaderMenuUtil = HeaderMenuUtil;
    class RecommendUtil {
        /**
         * おすすめ商品を取得して表示
         */
        static addRecommendItemArea() {
            const bdr = new BDR();
            const gid = $("[data-gid-for-header]").data("gid-for-header");
            bdr.rid = 20;
            bdr.dispCnt = 6;
            if (gid !== undefined) {
                bdr.userId = gid;
            }
            bdr.onSuccess = this.callback.bind(this);
            bdr.request();
        }
        static async callback(bdr, items) {
            let productCodeList = [];
            for (const item of items) {
                productCodeList.push(item.item_id);
            }
            const recommendItemEdges = await jun.ProductUtil.getProductData(productCodeList);
            if (recommendItemEdges === false) {
                return;
            }
            let $recommendItems = [];
            for (const edge of recommendItemEdges) {
                $recommendItems.push($(jun.tpl.itemArea(edge.node)));
            }
            if ($recommendItems.length > 0) {
                $("[data-recommend-items]").append($recommendItems);
                $("[data-recommend-items-area]").removeClass(jun.CLASS_HIDE);
            }
        }
    }
    jun.RecommendUtil = RecommendUtil;
    class ProductUtil {
        /**
         * 品番から商品を取得
         */
        static async getProductData(productCodeList) {
            if (productCodeList.length == 0) {
                return false;
            }
            let query = jun.BLANK;
            for (const code of productCodeList) {
                if (query == jun.BLANK) {
                    query = "tag:" + code;
                }
                else {
                    query += " OR tag:" + code;
                }
            }
            const params = {
                query: jun.graphql.queryProduct,
                variables: {
                    codeQuery: query,
                },
            };
            let resObj = false;
            await jun.storefront.exeStoreFront(params, (res) => {
                if (res.data.products.edges.length > 0) {
                    resObj = res.data.products.edges;
                }
            });
            return resObj;
        }
    }
    jun.ProductUtil = ProductUtil;
    class TrackingUtil {
        static resetWaitTime() {
            this.wait_time = 100;
        }
        static appendImg(query = {}) {
            return;
            const imgUrl = new URL(jun.CUSTOM_APP_URL + "/images/jun_app_tracking.png");
            Object.keys(query).forEach((name) => {
                imgUrl.searchParams.append(name, query[name]);
            });
            try {
                const checkout = jun.CheckoutUtil.getCheckoutData();
                imgUrl.searchParams.append("checkout_id", checkout.id);
            }
            catch (e) {
                imgUrl.searchParams.append("checkout_id", "no_id");
            }
            imgUrl.searchParams.append("ver", new Date().getTime().toString()); // キャッシュ対策
            const adminCheckoutId = $(".product-table").data("adminCheckoutId");
            if (adminCheckoutId != undefined) {
                imgUrl.searchParams.append("admin_checkout_id", adminCheckoutId);
            }
            imgUrl.searchParams.append("url", window.location.href);
            const content = '<img src="' +
                imgUrl.href +
                '" alt="tracking_jun_app" width="1" height="1">';
            setTimeout(function () {
                $("body").append(content);
            }, jun.TrackingUtil.wait_time);
            jun.TrackingUtil.wait_time += 100;
        }
    }
    TrackingUtil.wait_time = 100;
    jun.TrackingUtil = TrackingUtil;
    class Logger {
        static async info(extraParams = {}) {
            await this.post(extraParams, false);
        }
        static async error(extraParams = {}) {
            await this.post(extraParams, true);
        }
        static async post(extraParams, isError = true) {
            const init = {
                method: "post",
                mode: "cors",
                headers: Logger.getHeader(),
                body: JSON.stringify(Logger.getParams(extraParams, isError)),
            };
            await jun.FetchUtil.fetch(jun.CUSTOM_APP_URL + "/api/log", init, (res) => {
                var _a;
                if (jun.isDefined((_a = res.error) === null || _a === void 0 ? void 0 : _a.code)) {
                    return;
                }
            });
        }
        static getParams(extraParams, isError) {
            const context = {
                url: window.location.href,
                search: window.location.search,
                user_agent: window.navigator.userAgent.toLocaleLowerCase(),
            };
            return {
                is_error: isError,
                context: context,
                data: extraParams,
            };
        }
        static getHeader() {
            return {
                "Content-Type": "application/json",
                Accept: "application/json",
            };
        }
    }
    jun.Logger = Logger;
})(jun || (jun = {}));
var jun;
(function (jun) {
    var login;
    (function (login) {
        class CustomApp {
            constructor() {
                //
            }
            static async createNonce(socialLoginType, returnUrl) {
                const resource = jun.CUSTOM_APP_URL + "/api/customer/create_nonce";
                const init = {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({
                        social_login_type: socialLoginType,
                        return_to: returnUrl,
                    }),
                };
                let nonce = null;
                await jun.FetchUtil.fetch(resource, init, (res) => {
                    if (res.error) {
                        nonce = null;
                    }
                    nonce = res.data.nonce;
                });
                return nonce;
            }
        }
        login.CustomApp = CustomApp;
    })(login = jun.login || (jun.login = {}));
})(jun || (jun = {}));
/// <reference path="../common/common.ts" />
/// <reference path="./custom_app.ts" />
var jun;
(function (jun) {
    var login;
    (function (login) {
        class Application extends jun.AbstractApplication {
            constructor() {
                super(...arguments);
                this.returnUrlAfterLogin = null;
                this.view = null;
                this.isSubmitted = false;
                this.el = {
                    body: "body",
                    defaultLoginBtn: "#submit-default",
                    socialLoginLink: ".c-btn-2__link",
                    docomoLoginLink: "#submit-docomo",
                    rakutenLoginLink: "#submit-rakuten",
                    lineLoginLink: "#submit-line", //20211220 JUN-773
                    appleLoginLink: "#submit-apple", //20220323 JUN-773
                    errorTitle: ".c-box__lead",
                    errorDetail: ".c-box__txt",
                    inputReturnTo: 'input:hidden[name="return_to"]',
                    inputView: 'input:hidden[name="view"]',
                    linkToRegister: "#link-register",
                    linkToGidIndex: ".link-gid-index",
                    form: "#form-login",
                };
            }
            async init() {
                var _a;
                const customApp = jun.login.CustomApp;
                const me = this;
                const params = new URLSearchParams(window.location.search);
                // return_to URL 処理
                this.returnUrlAfterLogin = me.getReturnUrl(params);
                this.setReturnUrlToForm(this.returnUrlAfterLogin);
                // view 処理
                this.view = me.getView(params);
                this.setViewToForm(this.view);
                //JUN-773 20220518 ヤプリの時のみ表示する
                if (jun.isYappli()) {
                    $(".link-apple-login").removeClass(jun.CLASS_HIDE);
                }
                // error表示
                const errorStatus = me.filterErrorStatus(params);
                if (errorStatus) {
                    !$(me.el.body).hasClass("error") && $(me.el.body).addClass("error");
                    if (errorStatus.code ==
                        jun.ERROR_CODE_FAILED_TO_EMAIL_HAS_ALREADY_BEEN_TAKEN) {
                        $(me.el.errorTitle).html(errorStatus.title);
                    }
                    else {
                        $(me.el.errorTitle).text(errorStatus.title);
                    }
                    errorStatus.details.length &&
                        $(me.el.errorDetail).html(errorStatus.details.join("<br>"));
                    if (errorStatus.code ===
                        jun.ERROR_CODE_FAILED_TO_CONVERT_FROM_GID_TO_SHOPIFY) {
                        let gidIndexUrl = decodeURIComponent((_a = params.get("change_info_url")) !== null && _a !== void 0 ? _a : "");
                        if (gidIndexUrl === "") {
                            gidIndexUrl = jun.GID_INDEX_URL;
                        }
                        $(me.el.linkToGidIndex).html(`<a href="${gidIndexUrl}" target="_blank" style="text-decoration: underline">会員情報（JUN GLOBAL IDサイトに遷移します）</a>`);
                    }
                }
                /**
                 * 楽天ログイン
                 */
                $(this.el.rakutenLoginLink).on("click", async function (event) {
                    if (me.isSubmitted) {
                        return;
                    }
                    me.changeSubmitFlg(true);
                    // @ts-ignore
                    const nonce = await customApp.createNonce("social_plus_login", me.returnUrlAfterLogin);
                    if (!nonce) {
                        me.changeSubmitFlg(false);
                        alert("エラーが発生しました。お手数をおかけしますが再度お試しください。");
                        return;
                    }
                    sessionStorage.setItem("nonce", nonce);
                    // コールバックURL
                    const callbackUrl = new URL(`${jun.CUSTOM_APP_URL}/api/customer/social_plus/login`);
                    callbackUrl.searchParams.set("nonce", nonce);
                    // 失敗時コールバックURL
                    const callbackUrlIfFailed = new URL(`${location.protocol}/${location.host}/account/login`);
                    // SocialPLUSへのリダイレクトURL
                    const url = new URL("https://api.socialplus.jp/jun-jadore/jun-jadore/rakuten/authenticate");
                    url.searchParams.set("callback", callbackUrl.href);
                    url.searchParams.set("callback_if_failed", callbackUrlIfFailed.href);
                    url.searchParams.set("registration", "true");
                    url.searchParams.set("trcode", "ra");
                    setTimeout(function () {
                        location.href = url.href;
                    }, 0);
                });
                /**
                 * LINEログイン
                 * 20211220 JUN-773
                 */
                $(this.el.lineLoginLink).on("click", async function (event) {
                    if (me.isSubmitted) {
                        return;
                    }
                    me.changeSubmitFlg(true);
                    // @ts-ignore
                    const nonce = await customApp.createNonce("social_plus_login_line", me.returnUrlAfterLogin);
                    if (!nonce) {
                        me.changeSubmitFlg(false);
                        alert("エラーが発生しました。お手数をおかけしますが再度お試しください。");
                        return;
                    }
                    sessionStorage.setItem("nonce", nonce);
                    // コールバックURL
                    const callbackUrl = new URL(`${jun.CUSTOM_APP_URL}/api/customer/social_plus/login`);
                    callbackUrl.searchParams.set("nonce", nonce);
                    // 失敗時コールバックURL
                    const callbackUrlIfFailed = new URL(`${location.protocol}/${location.host}/account/login`);
                    // SocialPLUSへのリダイレクトURL
                    const url = new URL("https://api.socialplus.jp/jun-jadore/jun-jadore/line/authenticate");
                    url.searchParams.set("callback", callbackUrl.href);
                    url.searchParams.set("callback_if_failed", callbackUrlIfFailed.href);
                    url.searchParams.set("registration", "true");
                    url.searchParams.set("trcode", "li");
                    setTimeout(function () {
                        location.href = url.href;
                    }, 0);
                });
                /**
                 * Appleログイン
                 * 20220323 JUN-773
                 */
                $(this.el.appleLoginLink).on("click", async function (event) {
                    if (me.isSubmitted) {
                        return;
                    }
                    me.changeSubmitFlg(true);
                    // @ts-ignore
                    const nonce = await customApp.createNonce("social_plus_login_apple", me.returnUrlAfterLogin);
                    if (!nonce) {
                        me.changeSubmitFlg(false);
                        alert("エラーが発生しました。お手数をおかけしますが再度お試しください。");
                        return;
                    }
                    sessionStorage.setItem("nonce", nonce);
                    // コールバックURL
                    const callbackUrl = new URL(`${jun.CUSTOM_APP_URL}/api/customer/social_plus/login`);
                    callbackUrl.searchParams.set("nonce", nonce);
                    // 失敗時コールバックURL
                    const callbackUrlIfFailed = new URL(`${location.protocol}/${location.host}/account/login`);
                    // SocialPLUSへのリダイレクトURL
                    const url = new URL("https://a60dbde87f.auth.socialplus.jp/jun-jadore/jun-jadore/apple/authenticate");
                    url.searchParams.set("callback", callbackUrl.href);
                    url.searchParams.set("callback_if_failed", callbackUrlIfFailed.href);
                    url.searchParams.set("registration", "true");
                    setTimeout(function () {
                        location.href = url.href;
                    }, 0);
                });
                /**
                 * ドコモログイン
                 */
                $(this.el.docomoLoginLink).on("click", async function (event) {
                    if (me.isSubmitted) {
                        return;
                    }
                    me.changeSubmitFlg(true);
                    // @ts-ignore
                    const nonce = await customApp.createNonce("docomo_login", me.returnUrlAfterLogin);
                    if (!nonce) {
                        me.changeSubmitFlg(false);
                        alert("エラーが発生しました。お手数をおかけしますが再度お試しください。");
                        return;
                    }
                    sessionStorage.setItem("nonce", nonce);
                    const url = new URL(`${jun.CUSTOM_APP_URL}/api/customer/d_account/request_auth`);
                    url.searchParams.set("action_type", "login");
                    url.searchParams.set("nonce", nonce);
                    setTimeout(function () {
                        location.href = url.href;
                    }, 0);
                });
                /**
                 * 新規会員登録ページへ
                 */
                $(this.el.linkToRegister).on("click", async function (event) {
                    const url = new URL(location.protocol + "//" + location.hostname + "/account/register");
                    if (me.returnUrlAfterLogin) {
                        url.searchParams.set("return_to_url_from_login", me.returnUrlAfterLogin);
                    }
                    if (me.view) {
                        url.searchParams.set("view", me.view);
                    }
                    location.href = url.href;
                });
                $(this.el.form).on("submit", function (event) {
                    if (me.isSubmitted) {
                        return false;
                    }
                    else {
                        me.changeSubmitFlg(true);
                    }
                });
            }
            display() { }
            changeSubmitFlg(v) {
                v ? jun.MaskUtil.addMask() : jun.MaskUtil.removeMask();
                this.isSubmitted = v;
            }
            /**
             * return先のURLを決定する
             *
             * @private
             */
            filterReturnUrl(params) {
                let result = null;
                const targetNames = ["checkout_url", "cart_url", "return_url"];
                targetNames.forEach((name) => {
                    const value = params.get(name);
                    if (value && value !== "") {
                        result = [name, decodeURI(value)];
                    }
                });
                return result;
            }
            /**
             * URLパラメータからエラー情報を取得する
             *
             * @private
             */
            filterErrorStatus(params) {
                var _a;
                const error_code = params.get("error_code");
                if (!error_code) {
                    return null;
                }
                const details = (_a = params.get("error_details")) !== null && _a !== void 0 ? _a : "";
                const result = {
                    code: decodeURI(error_code),
                    title: decodeURI(params.get("error_message")),
                    details: decodeURI(details).split(","),
                };
                return result;
            }
            getReturnUrl(params) {
                let result = null;
                const returnUrlParam = this.filterReturnUrl(params);
                if (returnUrlParam) {
                    // URLにパラメータあり
                    document.cookie =
                        "return_url_after_login=" +
                            encodeURIComponent(returnUrlParam[1]) +
                            ";max-age=300";
                    result = returnUrlParam[1];
                }
                else if (this.filterErrorStatus(params) !== null) {
                    // cookieから復元を試みる
                    const cookieValue = document.cookie
                        .split("; ")
                        .find((row) => row.startsWith("return_url_after_login"));
                    if (cookieValue !== undefined) {
                        const newVal = cookieValue.split("=")[1];
                        document.cookie = "return_url_after_login=" + newVal + ";max-age=300";
                        result = decodeURIComponent(newVal);
                    }
                }
                return result;
            }
            getView(params) {
                let result = null;
                const v = params.get("view");
                if (v) {
                    document.cookie =
                        "login_view=" + encodeURIComponent(v) + ";max-age=300";
                    result = v;
                }
                else if (this.filterErrorStatus(params) !== null) {
                    // cookieから復元を試みる
                    const cookieValue = document.cookie
                        .split("; ")
                        .find((row) => row.startsWith("login_view"));
                    if (cookieValue !== undefined) {
                        const newVal = cookieValue.split("=")[1];
                        document.cookie = "login_view=" + newVal + ";max-age=300";
                        result = decodeURIComponent(newVal);
                    }
                }
                return result;
            }
            setReturnUrlToForm(url) {
                const newVal = url !== null && url !== void 0 ? url : "";
                $(this.el.inputReturnTo).val(newVal);
            }
            setViewToForm(v) {
                const newVal = v !== null && v !== void 0 ? v : "";
                $(this.el.inputView).val(newVal);
            }
        }
        login.Application = Application;
    })(login = jun.login || (jun.login = {}));
})(jun || (jun = {}));
jun.ready(new jun.login.Application());
